// extracted by mini-css-extract-plugin
module.exports = {"box":"index-module--box--afBAY"};